export const chamfrActiveTabMiddleware = ({ instantSearchInstance }) => {
  return {
    onStateChange({ uiState }) {},
    subscribe() {
      instantSearchInstance.on("render", () => {
        const results = Object.fromEntries(
          instantSearchInstance.mainIndex
            .getWidgets()
            .filter((w) => typeof w.getIndexId === "function")
            .map((w) => [w.getIndexId(), w.getResults?.()?.nbHits || 0])
        );

        const { products, suppliers, posts } = results || {};

        // If at least 1 group has results and was not triggered already
        if (
          (products || suppliers || posts) &&
          !instantSearchInstance._chamfrTabsClicked
        ) {
          instantSearchInstance._chamfrTabsClicked = true;
          let activeTab = "products";
          if (products === 0) {
            activeTab = "suppliers";
          }
          if (products === 0 && suppliers === 0) {
            activeTab = "blogs";
          }
          document.getElementById(`chamfr-search-tab-${activeTab}`)?.click?.();
        }
      });
    },
    unsubscribe() {},
  };
};
